import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Avatar,
  Checkbox,
  Divider,
} from "@mui/material";
import Loader from "../common/Loader";

export default function SupplierEvaluation() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader message="Loading supplier evaluation module..." />;
  }

  return (
    <Typography
      variant="h2"
      fontWeight="bold"
      color="Dark"
      mb={1}
      mt={2}
      p={20}
      sx={{ color: "#4F46E5" }}
    >
      This module is under development. Please check back later.{" "}
    </Typography>
  );
}
